import type {
  AiSettings,
  AuditEvent,
  Contact,
  Conversation,
  Doc,
  Faq,
  Message,
  PanelSettings,
  TestModeState,
  Ticket
} from './types';

/** Mock veri zamanı modül yüklenirken sabitlenir; böylece liste "2 dk" gibi gerçekçi görünür. */
const NOW = Date.now();

function ago(minutes: number): string {
  return new Date(NOW - minutes * 60_000).toISOString();
}

function inHours(hours: number): string {
  return new Date(NOW + hours * 3_600_000).toISOString();
}

export const MOCK_TEST_NUMBER = '+905518885886';
export const MOCK_OWNER: import('./types').User = {
  id: 'u-owner',
  name: 'Tolga Erdem',
  email: 'tolga@softwareeni.com',
  role: 'owner'
};
export const MOCK_AGENT: import('./types').User = {
  id: 'u-agent',
  name: 'Selin Aydın',
  email: 'selin@softwareeni.com',
  role: 'agent'
};

export const conversations: Conversation[] = [
  {
    id: 'c-1',
    contactId: 'k-1',
    phone: '+905321234567',
    name: 'Ayşe Demir',
    lastMessage: 'Kargom iki gündür aynı şubede görünüyor, ne zaman gelir?',
    lastAt: ago(2),
    unread: 2,
    status: 'open',
    assignedTo: null,
    aiState: 'ai',
    labels: ['kargo'],
    isTest: false,
    waitingSince: ago(18)
  },
  {
    id: 'c-2',
    contactId: 'k-2',
    phone: MOCK_TEST_NUMBER,
    name: 'Test numarası',
    lastMessage: 'Test mesajı — guard kontrolü',
    lastAt: ago(9),
    unread: 0,
    status: 'open',
    assignedTo: null,
    aiState: 'ai',
    labels: ['test'],
    isTest: true,
    waitingSince: null
  },
  {
    id: 'c-3',
    contactId: 'k-3',
    phone: '+905051112233',
    name: 'Mehmet Kaya',
    lastMessage: 'İade için hangi adrese göndereceğim?',
    lastAt: ago(26),
    unread: 1,
    status: 'pending',
    assignedTo: 'u-agent',
    aiState: 'human',
    labels: ['iade'],
    isTest: false,
    waitingSince: ago(52)
  },
  {
    id: 'c-4',
    contactId: 'k-4',
    phone: '+905419998877',
    name: null,
    lastMessage: 'Toplu alımda indirim var mı?',
    lastAt: ago(41),
    unread: 3,
    status: 'open',
    assignedTo: null,
    aiState: 'ai',
    labels: ['teklif'],
    isTest: false,
    waitingSince: ago(41)
  },
  {
    id: 'c-5',
    contactId: 'k-5',
    phone: '+905369876543',
    name: 'Zeynep Şahin',
    lastMessage: 'Mutfak robotu stokta var mı?',
    lastAt: ago(64),
    unread: 0,
    status: 'open',
    assignedTo: null,
    aiState: 'ai',
    labels: ['stok'],
    isTest: false,
    waitingSince: null
  },
  {
    id: 'c-6',
    contactId: 'k-6',
    phone: '+905437778899',
    name: 'Burak Yılmaz',
    lastMessage: 'Ürün hasarlı geldi, fotoğrafı gönderiyorum.',
    lastAt: ago(96),
    unread: 0,
    status: 'open',
    assignedTo: 'u-owner',
    aiState: 'human',
    labels: ['hasar', 'iade'],
    isTest: false,
    waitingSince: ago(96)
  },
  {
    id: 'c-7',
    contactId: 'k-7',
    phone: '+905552223344',
    name: 'Elif Çelik',
    lastMessage: 'Teşekkürler, sorun çözüldü.',
    lastAt: ago(210),
    unread: 0,
    status: 'closed',
    assignedTo: 'u-agent',
    aiState: 'paused',
    labels: [],
    isTest: false,
    waitingSince: null
  },
  {
    id: 'c-8',
    contactId: 'k-8',
    phone: '+905077778811',
    name: null,
    lastMessage: 'QR menü linkim açılmıyor, müşteriler şikayet ediyor.',
    lastAt: ago(180),
    unread: 1,
    status: 'open',
    assignedTo: null,
    aiState: 'ai',
    labels: ['ankaraqr'],
    isTest: false,
    waitingSince: ago(180)
  },
  {
    id: 'c-9',
    contactId: 'k-9',
    phone: '+905303334455',
    name: 'Can Özkan',
    lastMessage: 'Fatura adresimi değiştirmek istiyorum.',
    lastAt: ago(320),
    unread: 0,
    status: 'pending',
    assignedTo: null,
    aiState: 'paused',
    labels: ['fatura'],
    isTest: false,
    waitingSince: ago(320)
  },
  {
    id: 'c-10',
    contactId: 'k-10',
    phone: '+905428889900',
    name: 'Deniz Arslan',
    lastMessage: 'Sipariş onayı gelmedi, kontrol eder misiniz?',
    lastAt: ago(1500),
    unread: 0,
    status: 'open',
    assignedTo: null,
    aiState: 'ai',
    labels: [],
    isTest: false,
    waitingSince: null
  }
];

export const messages: Message[] = [
  // c-1 — kargo
  { id: 'm-101', conversationId: 'c-1', author: 'customer', kind: 'text', body: 'Merhaba, siparişim nerede?', at: ago(52) },
  {
    id: 'm-102',
    conversationId: 'c-1',
    author: 'ai',
    kind: 'text',
    body: 'Merhaba Ayşe Hanım. Siparişinizi buldum: #FZ-24815, kargo takip numarası 7412 8890 1123. Son hareket: 11 Kas 09:14, Ankara aktarma merkezi.',
    at: ago(51),
    aiConfidence: 0.86,
    aiSources: ['fizipazar/siparis', 'SSS: kargo takibi']
  },
  { id: 'm-103', conversationId: 'c-1', author: 'customer', kind: 'text', body: 'Teşekkürler. Peki ne zaman elime ulaşır?', at: ago(48) },
  {
    id: 'm-104',
    conversationId: 'c-1',
    author: 'ai',
    kind: 'text',
    body: 'Tahmini teslim 13 Kasım. Kargo firması yoğunluk bildirmedi.',
    at: ago(47),
    aiConfidence: 0.71,
    aiSources: ['fizipazar/siparis']
  },
  { id: 'm-105', conversationId: 'c-1', author: 'customer', kind: 'text', body: 'Kargom iki gündür aynı şubede görünüyor, ne zaman gelir?', at: ago(2) },
  {
    id: 'm-106',
    conversationId: 'c-1',
    author: 'system',
    kind: 'system',
    body: 'AI güveni düşük (0.42) — konuşma ajana yönlendirilmeye hazır.',
    at: ago(2)
  },
  {
    id: 'm-107',
    conversationId: 'c-1',
    author: 'agent',
    kind: 'text',
    body: 'Kargo firmasıyla görüşüyorum, 10 dakika içinde döneceğim.',
    at: ago(30),
    status: 'read'
  },
  {
    id: 'm-108',
    conversationId: 'c-1',
    author: 'agent',
    kind: 'text',
    body: "İç not: şube kaydı 12 Kas 16:40'ta güncellenmemiş, kargo firmasını arayacağım.",
    at: ago(29),
    isNote: true
  },
  {
    id: 'm-109',
    conversationId: 'c-1',
    author: 'customer',
    kind: 'image',
    body: 'Kargo takip ekranı',
    at: ago(25),
    mediaName: 'kargo-takip.png',
    mediaSize: 184_320
  },
  {
    id: 'm-110',
    conversationId: 'c-1',
    author: 'agent',
    kind: 'text',
    body: 'Kargo firması kaydı güncellenmemiş; yeniden sevk talebi açtım.',
    at: ago(20),
    status: 'failed',
    blockedReason: 'WA_SEND_FAILED'
  },

  // c-2 — test
  { id: 'm-201', conversationId: 'c-2', author: 'customer', kind: 'text', body: 'Test mesajı — guard kontrolü', at: ago(9) },
  {
    id: 'm-202',
    conversationId: 'c-2',
    author: 'ai',
    kind: 'text',
    body: 'Test modu yanıtı: guard izinli numarayı doğruladı, mesaj gönderildi.',
    at: ago(9),
    aiConfidence: 0.95,
    aiSources: ['policy/test-mode']
  },

  // c-3 — iade
  { id: 'm-301', conversationId: 'c-3', author: 'customer', kind: 'text', body: 'Ürünü iade etmek istiyorum.', at: ago(60) },
  {
    id: 'm-302',
    conversationId: 'c-3',
    author: 'ai',
    kind: 'text',
    body: 'İade koşulları: teslimattan sonra 14 gün içinde, kullanılmamış ve orijinal ambalajında. Kargo ücreti bizden.',
    at: ago(59),
    aiConfidence: 0.88,
    aiSources: ['PDF: iade-kosullari.pdf s.2', 'SSS: iade']
  },
  { id: 'm-303', conversationId: 'c-3', author: 'customer', kind: 'text', body: 'İade için hangi adrese göndereceğim?', at: ago(26) },
  {
    id: 'm-304',
    conversationId: 'c-3',
    author: 'agent',
    kind: 'text',
    body: 'Merhaba Mehmet Bey, iade kodu oluşturdum: İADE-7741. Aşağıdaki adrese gönderebilirsiniz.',
    at: ago(24),
    status: 'delivered'
  },
  {
    id: 'm-305',
    conversationId: 'c-3',
    author: 'agent',
    kind: 'text',
    body: 'İç not: iade kargo anlaşması Aras Kargo, müşteriye kod iletildi.',
    at: ago(23),
    isNote: true
  },

  // c-4 — teklif
  { id: 'm-401', conversationId: 'c-4', author: 'customer', kind: 'text', body: 'Toplu alımda indirim var mı?', at: ago(41) },

  // c-5 — stok
  { id: 'm-501', conversationId: 'c-5', author: 'customer', kind: 'text', body: 'Mutfak robotu stokta var mı?', at: ago(64) },
  {
    id: 'm-502',
    conversationId: 'c-5',
    author: 'ai',
    kind: 'text',
    body: 'Mutfak robotu şu anda stokta: 3 adet, 12.499 TL. Kargo 2 iş günü.',
    at: ago(63),
    aiConfidence: 0.93,
    aiSources: ['fizipazar/katalog']
  },

  // c-6 — hasar
  { id: 'm-601', conversationId: 'c-6', author: 'customer', kind: 'text', body: 'Ürün hasarlı geldi.', at: ago(100) },
  { id: 'm-602', conversationId: 'c-6', author: 'customer', kind: 'image', body: 'Hasarlı ürün', at: ago(96), mediaName: 'hasar-1.jpg', mediaSize: 892_100 },

  // c-8 — ankaraqr
  { id: 'm-801', conversationId: 'c-8', author: 'customer', kind: 'text', body: 'QR menü linkim açılmıyor, müşteriler şikayet ediyor.', at: ago(180) }
];

export const contacts: Contact[] = [
  {
    id: 'k-1',
    phone: '+905321234567',
    name: 'Ayşe Demir',
    optIn: true,
    optInAt: ago(60 * 24 * 90),
    createdAt: ago(60 * 24 * 240),
    labels: ['kargo', 'tekrar-müşteri'],
    notes: 'Kargo takibinde titiz; SMS yerine WhatsApp tercih ediyor.',
    orders: [
      { id: 'FZ-24815', source: 'fizipazar', title: 'Mutfak robotu + 2 aksesuar', amount: '13.240,00 TL', status: 'Kargoda', at: ago(60 * 24 * 3), tracking: '7412 8890 1123' },
      { id: 'FZ-21002', source: 'fizipazar', title: 'Döküm tava seti', amount: '2.180,00 TL', status: 'Teslim edildi', at: ago(60 * 24 * 40), tracking: null }
    ],
    ticketCount: 2,
    lastSeenAt: ago(2),
    blocked: false
  },
  {
    id: 'k-3',
    phone: '+905051112233',
    name: 'Mehmet Kaya',
    optIn: true,
    optInAt: ago(60 * 24 * 30),
    createdAt: ago(60 * 24 * 120),
    labels: ['iade'],
    notes: '',
    orders: [{ id: 'FZ-24901', source: 'fizipazar', title: 'Blender', amount: '3.450,00 TL', status: 'İade sürecinde', at: ago(60 * 24 * 6), tracking: null }],
    ticketCount: 1,
    lastSeenAt: ago(26),
    blocked: false
  },
  {
    id: 'k-8',
    phone: '+905077778811',
    name: 'Yıldız Lokantası',
    optIn: false,
    optInAt: null,
    createdAt: ago(60 * 24 * 45),
    labels: ['ankaraqr', 'işletme'],
    notes: 'AnkaraQR müşterisi; menü token yenilendi.',
    orders: [],
    ticketCount: 3,
    lastSeenAt: ago(180),
    blocked: false
  }
];

export const tickets: Ticket[] = [
  {
    id: 'TKT-20261102-0042',
    no: 'TKT-20261102-0042',
    subject: 'Toplu alım teklifi — 40 adet mutfak robotu',
    email: 'satinalma@ornekfirma.com',
    phone: '+905419998877',
    status: 'open',
    priority: 'high',
    channel: 'both',
    slaDueAt: inHours(3.2),
    createdAt: ago(41),
    assignee: null,
    summary: 'Müşteri 40 adet mutfak robotu için kurumsal teklif istiyor. AI fiyat kategorisini tanıdı, e-posta istedi, ticket açtı.',
    aiSources: ['SSS: kurumsal satış', 'fizipazar/katalog'],
    messages: [
      { id: 'tm-1', channel: 'whatsapp', author: 'customer', body: 'Toplu alımda indirim var mı? 40 adet alacağız.', at: ago(41) },
      { id: 'tm-2', channel: 'whatsapp', author: 'ai', body: 'Kurumsal alımlar için teklif hazırlıyoruz. E-posta adresinizi paylaşır mısınız?', at: ago(40) },
      { id: 'tm-3', channel: 'whatsapp', author: 'customer', body: 'satinalma@ornekfirma.com', at: ago(39) },
      { id: 'tm-4', channel: 'email', author: 'ai', body: 'Talebiniz oluşturuldu: TKT-20261102-0042. Ekibimiz iş saatlerinde 4 saat içinde dönecek.', at: ago(38), subject: '[TKT-20261102-0042] Teklif talebiniz alındı' }
    ],
    conversationId: 'c-4',
    isTest: false
  },
  {
    id: 'TKT-20261101-0038',
    no: 'TKT-20261101-0038',
    subject: 'Hasarlı ürün — fotoğraflı bildirim',
    email: 'burak.yilmaz@ornek.com',
    phone: '+905437778899',
    status: 'pending',
    priority: 'high',
    channel: 'whatsapp',
    slaDueAt: inHours(-1.5),
    createdAt: ago(96),
    assignee: 'u-owner',
    summary: 'Ürün hasarlı teslim edilmiş, müşteri fotoğraf gönderdi. Değişim veya iade kararı bekleniyor.',
    aiSources: ['Görsel: hasar-1.jpg'],
    messages: [
      { id: 'tm-5', channel: 'whatsapp', author: 'customer', body: 'Ürün hasarlı geldi, fotoğrafı gönderiyorum.', at: ago(96) },
      { id: 'tm-6', channel: 'whatsapp', author: 'agent', body: 'Merhaba Burak Bey, fotoğrafı aldık. Değişim talebini açtım, onay için 1 iş günü.', at: ago(90) }
    ],
    conversationId: 'c-6',
    isTest: false
  },
  {
    id: 'TKT-20261031-0031',
    no: 'TKT-20261031-0031',
    subject: 'İade kargo kodu talebi',
    email: null,
    phone: '+905051112233',
    status: 'open',
    priority: 'normal',
    channel: 'whatsapp',
    slaDueAt: inHours(6),
    createdAt: ago(60),
    assignee: 'u-agent',
    summary: 'İade koşulları anlatıldı, müşteri kargo kodu istiyor.',
    aiSources: ['PDF: iade-kosullari.pdf s.2'],
    messages: [
      { id: 'tm-7', channel: 'whatsapp', author: 'customer', body: 'İade için hangi adrese göndereceğim?', at: ago(26) },
      { id: 'tm-8', channel: 'whatsapp', author: 'agent', body: 'İade kodu: İADE-7741. Aras Kargo ile gönderebilirsiniz.', at: ago(24) }
    ],
    conversationId: 'c-3',
    isTest: false
  },
  {
    id: 'TKT-20261030-0022',
    no: 'TKT-20261030-0022',
    subject: 'QR menü linki açılmıyor',
    email: 'yildiz@orneklokanta.com',
    phone: '+905077778811',
    status: 'pending',
    priority: 'normal',
    channel: 'both',
    slaDueAt: inHours(18),
    createdAt: ago(180),
    assignee: null,
    summary: 'AnkaraQR menü tokeni süresi dolmuş olabilir; teknik kontrol gerekiyor.',
    aiSources: ['ankaraqr/menu'],
    messages: [
      { id: 'tm-9', channel: 'whatsapp', author: 'customer', body: 'QR menü linkim açılmıyor, müşteriler şikayet ediyor.', at: ago(180) },
      { id: 'tm-10', channel: 'email', author: 'ai', body: 'Talebiniz oluşturuldu: TKT-20261030-0022.', at: ago(179), subject: '[TKT-20261030-0022] QR menü talebiniz alındı' }
    ],
    conversationId: 'c-8',
    isTest: false
  },
  {
    id: 'TKT-20261029-0014',
    no: 'TKT-20261029-0014',
    subject: 'Test ticket — canlıya çıkmadan kontrol',
    email: 'tolga@softwareeni.com',
    phone: MOCK_TEST_NUMBER,
    status: 'resolved',
    priority: 'low',
    channel: 'whatsapp',
    slaDueAt: inHours(-48),
    createdAt: ago(60 * 24 * 2),
    assignee: 'u-owner',
    summary: 'Test modunda açılan ticket; müşteriye e-posta gitmedi.',
    aiSources: ['policy/test-mode'],
    messages: [
      { id: 'tm-11', channel: 'whatsapp', author: 'customer', body: 'Test mesajı — guard kontrolü', at: ago(60 * 24 * 2) }
    ],
    conversationId: 'c-2',
    isTest: true
  }
];

export const faqs: Faq[] = [
  { id: 'f-1', question: 'Kargom ne zaman gelir?', answer: 'Siparişler 1-2 iş günü içinde kargoya verilir. Teslimat, kargo firmasının yoğunluğuna göre 1-3 iş günü sürer. Takip numarası SMS ile iletilir.', category: 'Kargo', tags: ['kargo', 'teslimat'], active: true, updatedAt: ago(60 * 24 * 5), hits: 412 },
  { id: 'f-2', question: 'İade koşulları nedir?', answer: 'Teslimattan sonra 14 gün içinde, kullanılmamış ve orijinal ambalajında iade edilebilir. İade kargo ücreti bizden.', category: 'İade', tags: ['iade', 'cayma'], active: true, updatedAt: ago(60 * 24 * 9), hits: 388 },
  { id: 'f-3', question: 'Kargo takip numarasını nereden bulurum?', answer: 'Sipariş onay e-postasındaki "Kargoya verildi" bağlantısından veya hesabım > siparişlerim ekranından görebilirsiniz.', category: 'Kargo', tags: ['kargo', 'takip'], active: true, updatedAt: ago(60 * 24 * 12), hits: 275 },
  { id: 'f-4', question: 'Kurumsal teklif nasıl alırım?', answer: 'Toplu alımlarda e-posta adresinizi paylaşmanız yeterli; satış ekibi 4 iş saati içinde teklifle döner.', category: 'Satış', tags: ['teklif', 'kurumsal'], active: true, updatedAt: ago(60 * 24 * 2), hits: 96 },
  { id: 'f-5', question: 'Fatura adresimi nasıl değiştiririm?', answer: 'Fatura kesilmeden önce destek ekibine yazın; kesildikten sonra düzeltme için iptal-iade faturası düzenlenir.', category: 'Fatura', tags: ['fatura', 'adres'], active: true, updatedAt: ago(60 * 24 * 20), hits: 141 },
  { id: 'f-6', question: 'QR menümü nasıl güncellerim?', answer: 'AnkaraQR panelinde Menüler > içerik düzenleme ekranından ürün ve fiyat güncelleyebilirsiniz. Değişiklik anında yayına girer.', category: 'AnkaraQR', tags: ['ankaraqr', 'menü'], active: true, updatedAt: ago(60 * 24 * 7), hits: 63 },
  { id: 'f-7', question: 'Kapıda ödeme var mı?', answer: 'Şu anda kapıda ödeme yok; kredi kartı ve havale kabul ediliyor.', category: 'Ödeme', tags: ['ödeme'], active: false, updatedAt: ago(60 * 24 * 60), hits: 12 },
  { id: 'f-8', question: 'Siparişim hasarlı geldi, ne yapmalıyım?', answer: 'Teslimattan sonra 48 saat içinde fotoğrafla birlikte yazın. Değişim veya iade seçeneklerini sunuyoruz; kargo ücreti bizden.', category: 'İade', tags: ['hasar', 'iade'], active: true, updatedAt: ago(60 * 24 * 3), hits: 58 }
];

export const docs: Doc[] = [
  { id: 'd-1', name: 'iade-kosullari.pdf', sizeBytes: 284_512, pages: 6, chunks: 34, status: 'ready', uploadedAt: ago(60 * 24 * 14), indexedAt: ago(60 * 24 * 14), proposedFaqs: 0 },
  { id: 'd-2', name: 'kargo-anlasmalari.pdf', sizeBytes: 156_800, pages: 3, chunks: 12, status: 'ready', uploadedAt: ago(60 * 24 * 10), indexedAt: ago(60 * 24 * 10), proposedFaqs: 0 },
  { id: 'd-3', name: 'garanti-sartlari.pdf', sizeBytes: 412_000, pages: 9, chunks: 51, status: 'ready', uploadedAt: ago(60 * 24 * 4), indexedAt: ago(60 * 24 * 4), proposedFaqs: 0 },
  { id: 'd-4', name: 'yeni-fiyat-listesi-2027.pdf', sizeBytes: 1_048_576, pages: 22, chunks: 0, status: 'processing', uploadedAt: ago(6), indexedAt: null, proposedFaqs: 0 },
  { id: 'd-5', name: 'urun-kilavuzu-tarayici.pdf', sizeBytes: 720_896, pages: 14, chunks: 0, status: 'failed', uploadedAt: ago(60 * 24 * 2), indexedAt: null, proposedFaqs: 0, error: 'OCR dili paketi eksik (tur)' }
];

export const auditEvents: AuditEvent[] = [
  { id: 'a-1', at: ago(1), actor: 'Tolga Erdem', action: 'test_mode.blocked_send', target: '+90 532 *** ** 67', ip: '127.0.0.1', result: 'denied', meta: 'TEST_MODE_BLOCKED — allowlist dışı' },
  { id: 'a-2', at: ago(2), actor: 'Selin Aydın', action: 'conversation.reply', target: 'c-1', ip: '127.0.0.1', result: 'ok', meta: null },
  { id: 'a-3', at: ago(6), actor: 'AI', action: 'ai.answer', target: 'c-5', ip: '—', result: 'ok', meta: 'confidence=0.93 sources=2' },
  { id: 'a-4', at: ago(9), actor: 'Tolga Erdem', action: 'test_mode.send', target: '+90 551 *** ** 86', ip: '127.0.0.1', result: 'ok', meta: 'allowlist' },
  { id: 'a-5', at: ago(24), actor: 'Selin Aydın', action: 'conversation.takeover', target: 'c-3', ip: '127.0.0.1', result: 'ok', meta: 'ai→human' },
  { id: 'a-6', at: ago(26), actor: 'AI', action: 'ticket.create', target: 'TKT-20261102-0042', ip: '—', result: 'ok', meta: 'source=whatsapp' },
  { id: 'a-7', at: ago(41), actor: 'AI', action: 'ai.escalate', target: 'c-4', ip: '—', result: 'ok', meta: 'confidence=0.42 < 0.6' },
  { id: 'a-8', at: ago(52), actor: 'Tolga Erdem', action: 'settings.update', target: 'limits.dailyCap', ip: '127.0.0.1', result: 'ok', meta: '200 → 200' },
  { id: 'a-9', at: ago(64), actor: 'Sistem', action: 'policy.block', target: '+90 505 *** ** 33', ip: '—', result: 'denied', meta: 'CONTENT_BLOCKED — toplu gönderim' },
  { id: 'a-10', at: ago(96), actor: 'AI', action: 'ai.answer', target: 'c-6', ip: '—', result: 'error', meta: 'AI_UNAVAILABLE — 502' },
  { id: 'a-11', at: ago(180), actor: 'Tolga Erdem', action: 'library.upload', target: 'yeni-fiyat-listesi-2027.pdf', ip: '127.0.0.1', result: 'ok', meta: '1.0 MB' },
  { id: 'a-12', at: ago(210), actor: 'Selin Aydın', action: 'ticket.close', target: 'TKT-20261029-0014', ip: '127.0.0.1', result: 'ok', meta: null },
  { id: 'a-13', at: ago(320), actor: 'Tolga Erdem', action: 'auth.login', target: 'selfportal', ip: '127.0.0.1', result: 'ok', meta: 'SSO' },
  { id: 'a-14', at: ago(1500), actor: 'Sistem', action: 'wa.reconnect', target: 'device-1', ip: '—', result: 'ok', meta: 'reconnect 2/3' }
];

export const aiSettings: AiSettings = {
  model: 'deepseek-ai/DeepSeek-V4.1-Flash-1017',
  effort: 'low',
  confidenceThreshold: 0.6,
  dailyBudgetUsd: 5,
  promptExtra: 'Kısa yanıt ver. Fiyat/teklif sorularında e-posta iste ve ticket aç.',
  autoReply: true,
  maxRepliesPerConversation: 6
};

export const panelSettings: PanelSettings = {
  limits: { dailyCap: 200, perMinute: 5, warmupStage: '2. hafta — 150/gün', quietHours: '21:00–09:00' },
  email: {
    smtpHost: 'smtp.gmail.com',
    smtpPort: 587,
    smtpUser: 'destek@softwareeni.com',
    imapHost: 'imap.gmail.com',
    imapPort: 993,
    fromName: 'Tolga · Destek',
    fromAddress: 'destek@softwareeni.com',
    passwordSet: true
  },
  team: [
    { id: 'u-owner', name: 'Tolga Erdem', email: 'tolga@softwareeni.com', role: 'owner', lastActiveAt: ago(1), active: true },
    { id: 'u-agent', name: 'Selin Aydın', email: 'selin@softwareeni.com', role: 'agent', lastActiveAt: ago(3), active: true },
    { id: 'u-agent2', name: 'Mert Koç', email: 'mert@softwareeni.com', role: 'agent', lastActiveAt: ago(60 * 26), active: false }
  ],
  integrations: [
    { id: 'i-1', name: 'Fizipazar (WooCommerce)', status: 'connected', note: 'Salt-okur WC anahtarı, shop_manager', lastSyncAt: ago(4) },
    { id: 'i-2', name: 'AnkaraQR (PostgreSQL ro)', status: 'connected', note: 'ankaraqr_ro + view', lastSyncAt: ago(9) },
    { id: 'i-3', name: 'SelfPortal SSO', status: 'connected', note: 'OAuth2 PKCE', lastSyncAt: ago(320) },
    { id: 'i-4', name: 'DeepInfra (LLM)', status: 'connected', note: 'DeepSeek-V4.1-Flash-1017', lastSyncAt: ago(1) },
    { id: 'i-5', name: 'Telegram alarm', status: 'missing', note: 'ALERT_WEBHOOK_URL tanımlı değil', lastSyncAt: null }
  ]
};

export const testModeState: TestModeState = {
  enabled: true,
  runtimeMode: 'TEST',
  allowlist: [{ phone: MOCK_TEST_NUMBER, active: true, addedAt: ago(60 * 24 * 12) }],
  counters: { blocked24h: 3, allowed24h: 7, outboundToday: 7, dailyCap: 200, lastError: 'WA_SEND_FAILED (12 Kas 16:41)' },
  attempts: [
    { id: 't-1', at: ago(1), to: '+905321234567', decision: 'blocked', reason: 'NOT_ALLOWLISTED', kind: 'text' },
    { id: 't-2', at: ago(9), to: MOCK_TEST_NUMBER, decision: 'allowed', reason: 'allowlist', kind: 'text' },
    { id: 't-3', at: ago(64), to: '+905051112233', decision: 'blocked', reason: 'TEST_MODE_BLOCKED', kind: 'text' },
    { id: 't-4', at: ago(120), to: '+905437778899', decision: 'blocked', reason: 'NOT_ALLOWLISTED', kind: 'image' },
    { id: 't-5', at: ago(180), to: MOCK_TEST_NUMBER, decision: 'allowed', reason: 'allowlist', kind: 'image' }
  ]
};
